import http from '../../../utils/http'

export const validateRecaptcha = (data) =>{
  return http.post('/anon/recaptcha/actions/validate', data);
}

export const getRecaptchaPublicKey = () =>{
  return http.get('/anon/recaptcha/actions/public-key');
}